<script setup>
import { ref, onMounted } from 'vue';
import { 
  kPage,
  kApp, 
  kNavbar, 
  kBlock,
  kPopup,
  kPreloader,
  kLink
} from 'konsta/vue';

import { useRoute } from 'vue-router';
const route = useRoute();

import axios from 'axios'

import {usePopup} from '@/stores/popup'
const popupStore = usePopup();

import {useLoader} from '@/stores/loader'
const loaderStore = useLoader();

import {useDevice} from '@/stores/device'
const deviceStore = useDevice();

import {useConfig} from '@/stores/config'
const configStore = useConfig();

import BookingHeader from '@/components/BookingHeader.vue';
import Steps from '@/components/Steps.vue';

var pathname_parts = window.location.pathname.substring(1).split('/');
if(pathname_parts.length){
  configStore.account_slug = pathname_parts[0];
  axios.defaults.baseURL = import.meta.env.VITE_API_URL + '/' + configStore.account_slug;
}

const fallback_404 = ref(false)

if(configStore.account_slug){
  onMounted(async _ => {
    loaderStore.open();
    await configStore.get()

    if(!configStore.config) fallback_404.value = true;
    loaderStore.close();
  });
}

</script>

<template>
  <k-app theme="ios">
    <k-page 
      :class="[
        'block md:flex md:h-screen',
        route.name == 'appointmentDetail' ? 'bg-white' : ''
      ]">
      <div
        v-if="['stepService','stepTeam','stepDate','booking','confirm'].includes(route.name)"
        class="w-full block md:flex md:items-stretch md:w-1/3">
        <BookingHeader/>
      </div>

      <div 
        :class="[
          'w-full overflow-y-auto',
          ['stepService','stepTeam','stepDate','booking','confirm'].includes(route.name) ? 'py-5 md:w-2/3 md:bg-slate-100' : ''
        ]">
        <div
          v-if="['stepService','stepTeam','stepDate','booking','confirm'].includes(route.name)"
          class="hidden md:block px-4 mb-6">
          <Steps/>
        </div>

        <RouterView/>
      </div>
    </k-page>

    <k-popup :opened="loaderStore.loader" @backdropclick="() => (loaderStore.loader = false)">
      <div class="flex items-center justify-center w-screen h-screen flex-col">
        <img src="/images/logo.svg" class="w-6/12 mb-4"/>
        <k-preloader class="text-primary" />
      </div>
    </k-popup>

    <k-popup :opened="fallback_404" @backdropclick="() => (fallback_404 = false)">
      <k-block>
        Noooo.
        Pagina da completare, che spiega che questo account non esiste o non è più attivo.
        Mettere logo Prenotai e link a sito.
      </k-block>
    </k-popup>

    <k-popup class="overflow-y-auto" v-if="popupStore.popups.privacy_policy" :opened="popupStore.popups.privacy_policy" @backdropclick="() => (popupStore.popups.privacy_policy = false)">
      <k-navbar title="Privacy Policy">
        <template #right>
          <k-link navbar @click="() => (popupStore.popups.privacy_policy = false)"> Chiudi </k-link>
        </template>
      </k-navbar>

      <k-block v-html="configStore.config.privacy_policy"/>
    </k-popup>

    <k-popup v-if="popupStore.popups.terms_conditions" :opened="popupStore.popups.terms_conditions" @backdropclick="() => (popupStore.popups.terms_conditions = false)">
      <k-navbar title="Termini e Condizioni">
        <template #right>
          <k-link navbar @click="() => (popupStore.popups.terms_conditions = false)"> Chiudi </k-link>
        </template>
      </k-navbar>

      <k-block v-html="configStore.config.terms_conditions"/>
    </k-popup>


  </k-app>

</template>
